module.exports = __webpack_public_path__ + "img/bg_zd.7ccf41d0.png";